import App from './App';

function Main() {
    return (
        <div id='main' className="w-screen h-screen bg-cold bg-cover">
            <App />
        </div>
    );
}

export default Main;